(() => {
  'use strict';

  if (customElements.get('recently-viewed-products')) return;

  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('[data-recently-viewed-section]');
        this.grid = this.querySelector('[data-recently-viewed-grid]');
        this.limit = parseInt(this.dataset.limit, 10) || 4;
        this.minimum = parseInt(this.dataset.minimum, 10) || 1;
      }

      connectedCallback() {
        if (!this.section || !this.grid) return;

        const handles = this.getProductHandles();
        if (!handles.length) {
          this.removeSection();
          return;
        }

        this.renderProducts(handles);
      }

      getProductHandles() {
        const cookie = document.cookie
          .split('; ')
          .find((row) => row.startsWith('shopify_recently_viewed='));

        if (!cookie) return [];

        const handles = decodeURIComponent(cookie.split('=')[1])
          .split(' ')
          .filter(Boolean);

        if (window.location.pathname.includes('/products/') && handles.length > 0) {
          return handles.slice(1, this.limit + 1);
        }

        return handles.slice(0, this.limit);
      }

      async renderProducts(handles) {
        let rendered = 0;

        for (const handle of handles) {
          const html = await this.fetchProductCard(handle, rendered);
          if (!html) continue;

          const fragment = document.createElement('div');
          fragment.innerHTML = html;
          const content = fragment.querySelector('[data-api-content]');

          if (!content) continue;

          while (content.firstChild) {
            this.grid.appendChild(content.firstChild);
          }

          rendered += 1;
        }

        if (rendered < this.minimum) {
          this.removeSection();
          return;
        }

        this.prepareAnimations();
        this.section.classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('theme:scroll'));
      }

      prepareAnimations() {
        const animatedItems = this.querySelectorAll('[data-aos-custom-init]');
        const triggeredItems = new Set();

        if (!animatedItems.length) return;

        const animateItems = () => {
          requestAnimationFrame(() => {
            animatedItems.forEach((item) => item.classList.add('aos-animate'));
          });
          this.removeEventListener('theme:target:animate', handleTargetAnimate);
        };

        const handleTargetAnimate = (event) => {
          if (!event.detail || !Array.prototype.includes.call(animatedItems, event.detail)) return;

          triggeredItems.add(event.detail);

          if (triggeredItems.size >= animatedItems.length) {
            animateItems();
          }
        };

        this.addEventListener('theme:target:animate', handleTargetAnimate);
      }

      async fetchProductCard(handle, index) {
        try {
          const root = window.theme?.routes?.root || '/';
          const separator = root.endsWith('/') ? '' : '/';
          const response = await fetch(`${root}${separator}products/${handle}?section_id=api-recently-viewed-product-card`);

          if (!response.ok) return '';

          let html = await response.text();
          if (html.includes('data-unpublished')) return '';

          const delay = index * 150;
          const anchor = this.grid.id ? `#${this.grid.id}` : '';

          html = html.replaceAll('||itemAosDelay||', delay);
          html = html.replaceAll('||itemAosAnchor||', anchor);
          html = html.replaceAll('||itemIndex||', index);

          return html;
        } catch (error) {
          return '';
        }
      }

      removeSection() {
        this.section.remove();
      }
    }
  );
})();
